module.exports = __webpack_public_path__ + "static/a8-619b98f3f0830312e14bd122793b89e5.jpg";